import React from 'react';
import { getStatusBadgeClasses, formatStatusText } from '../utils/statusUtils';

const StatusBadge = ({ status, type = 'employee', 'data-testid': dataTestId }) => {
  const badgeClasses = getStatusBadgeClasses(status, type);
  const statusText = formatStatusText(status);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeClasses}`}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      {statusText}
    </span>
  );
};

export default StatusBadge; 